import React, { Fragment } from "react";
import ReferenceDataListTable from "./ReferenceDataListTable";
import { Box, Grid } from "@mui/material";
import { GridSpg, TableSkeleton } from "@duosoftbg/nacid-components";
import DeleteReferenceDataDialog from "./dialog/DeleteReferenceDataDialog";
import SaveReferenceDataDialog from "./dialog/SaveReferenceDataDialog";

const ReferenceDataList = ({ records, total, isLoading, onPageOrOrderChange, blockTable, group, filterFn }) => {
  const showTable = () => {
    return (
      <Fragment>
        <DeleteReferenceDataDialog filterFn={filterFn} records={records} total={total} />
        <SaveReferenceDataDialog filterFn={filterFn} />
        <ReferenceDataListTable
          records={records}
          total={total}
          onPageOrOrderChange={onPageOrOrderChange}
          blockTable={blockTable}
          group={group}
        />
      </Fragment>
    );
  };

  return (
    <Box>
      <Grid container spacing={1}>
        <GridSpg item xs={12}>
          {isLoading ? <TableSkeleton /> : showTable()}
        </GridSpg>
      </Grid>
    </Box>
  );
};

export default ReferenceDataList;
